var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9 18.7533L21.6733 18.5533C21.0303 17.9804 20.4674 17.3234 20 16.6C19.4895 15.6017 19.1835 14.5115 19.1 13.3933V10.1C19.1044 8.34374 18.4673 6.64632 17.3085 5.32665C16.1496 4.00698 14.5488 3.15591 12.8067 2.93333V2.07333C12.8067 1.83729 12.7129 1.61092 12.546 1.44401C12.3791 1.2771 12.1527 1.18333 11.9167 1.18333C11.6806 1.18333 11.4542 1.2771 11.2873 1.44401C11.1204 1.61092 11.0267 1.83729 11.0267 2.07333V2.94667C9.30017 3.18529 7.71865 4.0415 6.57502 5.35674C5.43139 6.67197 4.80315 8.3571 4.80667 10.1V13.3933C4.72317 14.5115 4.41718 15.6017 3.90667 16.6C3.44725 17.3216 2.89346 17.9785 2.26 18.5533L2.03333 18.7533V20.6333H21.9V18.7533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2133 21.3333C10.2718 21.7559 10.4812 22.1431 10.8029 22.4233C11.1245 22.7035 11.5367 22.8579 11.9633 22.8579C12.3899 22.8579 12.8021 22.7035 13.1238 22.4233C13.4455 22.1431 13.6549 21.7559 13.7133 21.3333H10.2133Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification_icon.176cec187a37044dd15055d6af0e44cb.svg";
export { ForwardRef as ReactComponent };